import { LocationNotesDTO } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useLocationNotes(locationId: string) {
  const url = `/v2/orm/location_notes/locations/${locationId}/notes`;
  const request = new Request(url);

  return useAuthenticatedRequest<LocationNotesDTO>(request, {
    queryKey: ['location_notes', locationId],
    refetchInterval: 30000,
    refetchOnWindowFocus: true,
    enabled: !!locationId,
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
  });
}
